import React from 'react';

import { APToast } from '@shared/components';

const APToastProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <>
      {children}
      <APToast />
    </>
  );
};

export default APToastProvider;
